import * as AllColors from "../constants/colors";

export function createAccordionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_BLACK"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "pulsingPurpleBright";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "pulsingPurpleBright";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "radiantRedBright";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "radiantRedBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "fieryFuchsiaBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "fieryFuchsiaBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "galvanicGreenBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "galvanicGreenBright";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "blazingBlueBright";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "blazingBlueBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "iridescentIndigoBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "iridescentIndigoBright";
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createAnchorNavigationMapDefinition() {
  let obj = {};
  return obj;
}
export function createAnswerCardMapDefinition() {
  let obj = {};
  obj["default"] = "bright";
  return obj;
}
export function createBadgeMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createBreadcrumbMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BLACK"]] = "brightWhite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightWhite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "brightWhite";
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createBottomDrawerMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createBulletListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BLACK"]] = "blazingBlueBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite25";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "blazingBlueBright";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "blazingBlueBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "galvanicGreenBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "galvanicGreenBright";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "blazingBlueBright";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "blazingBlueBright";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "blazingBlueBright";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "blazingBlueBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "blazingBlueBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "blazingBlueBright";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "blazingBlueBright";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "blazingBlueBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "blazingBlueBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "blazingBlueBright";
  obj["default"] = "brightWhite";
  return obj;
}
export function createBulletListDeprecatedMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createBusinesscardAuthorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createBusinesscardContactMapDefinition() {
  let obj = {};
  obj["default"] = "atmosphericAnthracite5";
  return obj;
}
export function createBoxMapDefinition() {
  let obj = {};
  obj["default"] = "brightWhite";
  return obj;
}
export function createButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_BLACK"]] = "brightWhite";
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createCaptionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "mellowYellowMuted";
  obj["default"] = "brightWhite";
  return obj;
}
export function createCardTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "fieryFuchsiaMuted";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "fieryFuchsiaBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightWhite";
  obj["default"] = "atmosphericAnthracite";
  return obj;
}
export function createCarouselMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BLACK"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createCheckboxMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightOnDark";
  obj[AllColors["COLOR_BLACK"]] = "brightOnDark";
  obj["default"] = "brightWhite";
  return obj;
}
export function createClickableImageMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createColorSeparatorMapDefinition() {
  let obj = {};
  return obj;
}
export function createCompassMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createContactBarMapDefinition() {
  let obj = {};
  obj["default"] = "brightWhite";
  return obj;
}
export function createContactLayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "atmosphericAnthracite";
  obj["default"] = "atmosphericAnthracite";
  return obj;
}
export function createContactListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BLACK"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createContentAggregatorMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createContentAggregatorItemMapDefinition() {
  let obj = {};
  obj["default"] = "brightWhite";
  return obj;
}
export function createContextMenuMapDefinition() {
  let obj = {};
  obj["default"] = "atmosphericAnthracite";
  return obj;
}
export function createContextMenuItemMapDefinition() {
  let obj = {};
  obj["default"] = "brightWhite";
  return obj;
}
export function createDataTableMapDefinition() {
  let obj = {};
  return obj;
}
export function createDateEventMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createDatePickerMapDefinition() {
  let obj = {};
  obj["default"] = "atmosphericAnthracite";
  return obj;
}
export function createDividerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightWhite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createDropdownMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightWhite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthraciteDark";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite25";
  obj[AllColors["COLOR_BLACK"]] = "black";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "mellowYellowBright";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "mellowYellowMuted";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "radiantRedBright";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "radiantRedMuted";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "pulsingPurpleBright";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "pulsingPurpleMuted";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "fieryFuchsiaBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "fieryFuchsiaMuted";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "galvanicGreenBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "galvanicGreenMuted";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "blazingBlueBright";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "blazingBlueMuted";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "iridescentIndigoBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "iridescentIndigoMuted";
  obj["default"] = "atmosphericAnthracite";
  return obj;
}
export function createDropdownOptionMapDefinition() {
  let obj = {};
  obj["default"] = "atmosphericAnthracite";
  return obj;
}
export function createErrorMessageMapDefinition() {
  let obj = {};
  obj["default"] = "radiantRedMuted";
  return obj;
}
export function createFileUploadMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite25";
  obj["default"] = "brightWhite";
  return obj;
}
export function createFilePreviewMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BLACK"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite5";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite25";
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellow";
  obj["default"] = "brightWhite";
  return obj;
}
export function createFooterBarMapDefinition() {
  let obj = {};
  return obj;
}
export function createFormMessageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "standard";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "standard";
  obj["default"] = "brightWhite";
  return obj;
}
export function createHeadlineMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightWhite";
  obj[AllColors["COLOR_BLACK"]] = "brightWhite";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "brightWhite";
  obj["default"] = "atmosphericAnthracite";
  return obj;
}
export function createIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createImageMapDefinition() {
  let obj = {};
  return obj;
}
export function createInfoIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BLACK"]] = "brightWhite";
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightWhite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "brightWhite";
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createInputMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightWhite";
  obj[AllColors["COLOR_BLACK"]] = "black";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "mellowYellowBright";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "mellowYellowMuted";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "radiantRedBright";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "radiantRedMuted";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "pulsingPurpleBright";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "pulsingPurpleMuted";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "fieryFuchsiaBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "fieryFuchsiaMuted";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "galvanicGreenBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "galvanicGreenMuted";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "blazingBlueBright";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "blazingBlueMuted";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "iridescentIndigoBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "iridescentIndigoMuted";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite5";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite25";
  obj["default"] = "atmosphericAnthracite";
  return obj;
}
export function createLinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createLinklistMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createMapMapDefinition() {
  let obj = {};
  return obj;
}
export function createMapInfoLayerMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createModalMapDefinition() {
  let obj = {};
  return obj;
}
export function createMultiContentStageMapDefinition() {
  let obj = {};
  obj["default"] = "atmosphericAnthracite5";
  return obj;
}
export function createNavigationMapDefinition() {
  let obj = {};
  return obj;
}
export function createNumberMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createOffsetTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createOffsetTeaser5MapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBrightOnWhite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "mellowYellowBrightOnAnthracite5";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "mellowYellowBrightOnAnthracite25";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "mellowYellowMuted";
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createPreloaderCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "colorful";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "colorful";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "colorful";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "colorful";
  obj[AllColors["COLOR_BLACK"]] = "colorful";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "brightWhite";
  return obj;
}
export function createPreloaderSquaresMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightWhite";
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createProgressCircleMapDefinition() {
  let obj = {};
  obj["default"] = "brightWhite";
  return obj;
}
export function createPromoFlagMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createPageHeaderMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createPictogramMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "mellowYellowBright";
  obj["default"] = "brightWhite";
  return obj;
}
export function createRteRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "brightWhite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "brightWhite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "brightWhite";
  obj[AllColors["COLOR_BLACK"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createRadioButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "blazingBlueBright";
  obj["default"] = "brightWhite";
  return obj;
}
export function createReadMoreMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createSectionMapDefinition() {
  let obj = {};
  obj["default"] = "brightWhite";
  return obj;
}
export function createSearchResultItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "brightWhite";
  obj[AllColors["COLOR_BLACK"]] = "brightWhite";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightWhiteOnMellowYellowBright";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "brightWhite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createSitelinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_BLACK"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "pulsingPurpleBright";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "pulsingPurpleBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "fieryFuchsiaBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "fieryFuchsiaBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "galvanicGreenBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "galvanicGreenBright";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "blazingBlueBright";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "blazingBlueBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "iridescentIndigoBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "iridescentIndigoBright";
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createSliderMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BLACK"]] = "mellowYellowOnDark";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "mellowYellowOnDark";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "brightWhite";
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createSpacerMapDefinition() {
  let obj = {};
  return obj;
}
export function createStageMapDefinition() {
  let obj = {};
  obj["default"] = "brightWhite";
  return obj;
}
export function createStepMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BLACK"]] = "brightOnDark";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightOnDark";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "mellowYellowOnAnthracite25";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightOnMellowYellow";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "brightOnMellowYellow";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "brightOnRadiantRed";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "brightOnRadiantRed";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "brightOnPulsingPurple";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "brightOnPulsingPurple";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "brightOnFieryFuchsia";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "brightOnFieryFuchsia";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "brightOnGalvanicGreen";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "brightOnGalvanicGreen";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "brightOnBlazingBlue";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "brightOnBlazingBlue";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "brightOnIridescentIndigo";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "brightOnIridescentIndigo";
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createStepsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BLACK"]] = "brightOnDark";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightOnDark";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "brightOnAnthracite5";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "brightOnAnthracite25";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightOnMellowYellowOnBright";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "brightOnMellowYellowOnBright";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "brightOnRadiantRedOnBright";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "brightOnRadiantRedOnBright";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "brightOnPulsingPurpleOnBright";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "brightOnPulsingPurpleOnBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "brightOnFieryFuchsiaOnBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "brightOnFieryFuchsiaOnBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "brightOnGalvanicGreenOnBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "brightOnGalvanicGreenOnBright";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "brightOnBlazingBlueOnBright";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "brightOnBlazingBlueOnBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "brightOnIridescentIndigoOnBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "brightOnIridescentIndigoOnBright";
  return obj;
}
export function createSwitchToggleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightWhite";
  obj[AllColors["COLOR_BLACK"]] = "brightWhite";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "brightWhite";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "brightWhite";
  obj["default"] = "atmosphericAnthracite";
  return obj;
}
export function createTableRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "brightWhite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite5";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite25";
  obj[AllColors["COLOR_BLACK"]] = "black";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "mellowYellowBright";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "mellowYellowMuted";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "pulsingPurpleBright";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "pulsingPurpleMuted";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "radiantRedBright";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "radiantRedMuted";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "fieryFuchsiaBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "fieryFuchsiaMuted";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "galvanicGreenBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "galvanicGreenMuted";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "blazingBlueBright";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "blazingBlueMuted";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "iridescentIndigoBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "iridescentIndigoMuted";
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createTabsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BLACK"]] = "mellowYellowBright";
  obj[AllColors["COLOR_MELLOW_YELLOW_BRIGHT"]] = "mellowYellowBright";
  obj[AllColors["COLOR_MELLOW_YELLOW_MUTED"]] = "mellowYellowBright";
  obj[AllColors["COLOR_RADIANT_RED_BRIGHT"]] = "mellowYellowBright";
  obj[AllColors["COLOR_RADIANT_RED_MUTED"]] = "mellowYellowBright";
  obj[AllColors["COLOR_PULSING_PURPLE_BRIGHT"]] = "mellowYellowBright";
  obj[AllColors["COLOR_PULSING_PURPLE_MUTED"]] = "mellowYellowBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_BRIGHT"]] = "mellowYellowBright";
  obj[AllColors["COLOR_FIERY_FUCHSIA_MUTED"]] = "mellowYellowBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_BRIGHT"]] = "mellowYellowBright";
  obj[AllColors["COLOR_GALVANIC_GREEN_MUTED"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BLAZING_BLUE_BRIGHT"]] = "mellowYellowBright";
  obj[AllColors["COLOR_BLAZING_BLUE_MUTED"]] = "mellowYellowBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_BRIGHT"]] = "mellowYellowBright";
  obj[AllColors["COLOR_IRIDESCENT_INDIGO_MUTED"]] = "mellowYellowBright";
  obj["default"] = "atmosphericAnthracite";
  return obj;
}
export function createTagPillMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "mellowYellowBright";
  obj["default"] = "brightWhite";
  return obj;
}
export function createTextMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT_WHITE"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE"]] = "brightWhite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE5"]] = "atmosphericAnthracite";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite";
  obj["default"] = "brightWhite";
  return obj;
}
export function createTextTeaserMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  obj[AllColors["COLOR_ATMOSPHERIC_ANTHRACITE25"]] = "atmosphericAnthracite25";
  return obj;
}
export function createThirdLevelNavigationMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createThirdLevelNavigationItemMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createTilesTeaserMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
export function createTooltipMapDefinition() {
  let obj = {};
  obj["default"] = "atmosphericAnthracite";
  return obj;
}
export function createVideoplayerMapDefinition() {
  let obj = {};
  obj["default"] = "brightWhite";
  return obj;
}
export function createViolatorMapDefinition() {
  let obj = {};
  obj["default"] = "mellowYellowBright";
  return obj;
}
